/* esm.sh - d3-transition@3.0.1/src/transition/duration */
export * from "/*d3-transition@3.0.1/esnext/src/transition/duration.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/duration.mjs";
